import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function OverlayLoading() {
  const { t } = useTranslation()
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        color: 'var(--muted-foreground)',
      }}
    >
      <Loader2 size={18} className="animate-spin" />
      <span style={{ fontSize: 13 }}>{t('documents.detail.loadingDocument')}</span>
    </div>
  )
}
